import React, { useEffect, useState } from "react";

import { Col, Dropdown, Row } from "react-bootstrap";

import { Calendar } from "react-feather";

const Header = ({ performQuery }) => {
  const [time, setTime] = useState("This Week");

  const timeKeyMap = {
    Today: "day",
    "This Week": "week",
    "This Month": "month",
  };

  useEffect(() => {
    performQuery(timeKeyMap[time]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [performQuery, time]);

  return (
    <Row className="mb-2 mb-xl-3">
      <Col xs="auto" className="d-none d-sm-block">
        <h3>Dashboard</h3>
      </Col>

      <Col xs="auto" className="ms-auto text-end mt-n1">
        <Dropdown className="d-inline me-2">
          <Dropdown.Toggle variant="light" className="bg-white shadow-sm">
            <Calendar className="feather align-middle mt-n1" /> {time}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setTime("Today")}>
              <p>Today</p>
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setTime("This Week")}>
              <p>This Week</p>
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setTime("This Month")}>
              <p>This Month</p>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* <Button variant="primary" className="shadow-sm me-1">
          <Filter className="feather" />
        </Button>
        <Button variant="primary" className="shadow-sm">
          <RefreshCw className="feather" />
        </Button> */}
      </Col>
    </Row>
  );
};

export default Header;
